module.exports = __webpack_public_path__ + "static/media/products-600x400.73903f54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/home/assets/products-600x400.jpg
// module id = 1083
// module chunks = 1